import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-informes_trasparencia',
  templateUrl: './informes_trasparencia.component.html',
  styleUrls: ['./informes_trasparencia.component.css']
})
export class Informes_trasparenciaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
